import request from '@/service/api'
import ConfigType from '@/service/api/type'
import qs from 'qs'
enum DocumentsApi {
    
    purchase = '/RestockOrder/purchase',//查询ERP采购单头
    testockType = '/RestockOrder/testockType',//查询ERP进货单单别
    department = '/RestockOrder/department',//查询ERP部门
    location = '/RestockOrder/location',//查询ERP库位
    page = '/RestockOrder/page',//分页查询任务
    RestockOrderAdd = '/RestockOrder/add',//添加进货单
    RestockOrderDelete = '/RestockOrder/delete',//删除进货单   
    RestockOrderAudit = '/RestockOrder/audit',//审核进货单   
    RestockOrderPush = '/RestockOrder/push',//推送进货单 
    CREATINGSHIPORDERSEND = '/PurchaseOrder/AdminCreateGoodsDeliveryList',//编辑
    CORFIRMCREATES = '/PurchaseOrder/AdminAddGoodsDelivery',//编辑确定按钮

    returnOrderPage = '/ReturnOrder/page',//分页查询退货单任务
    ReturnOrderAdd = '/ReturnOrder/add',//添加进货单
    ReturnOrderDelete = '/ReturnOrder/delete',//删除退货单   
    ReturnOrderPush = '/ReturnOrder/push',//推送退货单 
    getRestockOrder = '/ReturnOrder/getRestockOrder',//查询退货单对应进货单 
    ReturnPrint = '/ReturnOrder/ReturnPrint',//查询退货单对应进货单 
  
 
   
}
// 查询ERP采购单头
// export const purchase = (data: any): ConfigType<any> => {
//     return request({
//         url: `${DocumentsApi.purchase}?${qs.stringify(data)}`,
//         method: 'get',
//         params: data
//     })
// }
export const purchase = (data: any): ConfigType<any> => {
    return request({
        url: `${DocumentsApi.purchase}?${qs.stringify(data)}`,
        method: 'get',
        //params: data
    })
}
// 查询ERP进货单单别
export const testockType = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.testockType,
        method: 'get',
        params: data
    })
}
// 查询ERP部门
export const department = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.department,
        method: 'get',
        params: data
    })
}
// 查询ERP库位
export const location = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.location,
        method: 'get',
        params: data
    })
}
// 分页查询任务
export const page = (data: any): ConfigType<any> => {
    return request({
        url: `${DocumentsApi.page}?${qs.stringify(data)}`,
        method: 'get'
    })
}

// 供应商模块 - 采购单管理-新建送货单抽屉内部列表数据
export const getCreatingPage = (data: any): ConfigType<any> => {
    return request({
        url: `${DocumentsApi.CREATINGSHIPORDERSEND}?${qs.stringify(data)}`,
        method: 'get'
    })
}

export const CORFIRMCREATES = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.CORFIRMCREATES,
        method: 'post',
        data: data
    })
}

// 添加进货单
export const RestockOrderAdd = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.RestockOrderAdd,
        method: 'post',
        data: data
    })
}
// 删除进货单
export const RestockOrderDelete = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.RestockOrderDelete,
        method: 'post',
        data: data
    })
}

// 审核进货单
export const RestockOrderAudit = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.RestockOrderAudit,
        method: 'post',
        data: data
    })
}
 
// 推送进货单
export const RestockOrderPush = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.RestockOrderPush,
        method: 'post',
        data: data
    })
}
//////////退货单///////////////////////
// 分页查询退货任务
export const returnOrderPage = (data: any): ConfigType<any> => {
    return request({
        url: `${DocumentsApi.returnOrderPage}?${qs.stringify(data)}`,
        method: 'get'
    })
}
// 删除退货单
export const ReturnOrderDelete = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.ReturnOrderDelete,
        method: 'post',
        data: data
    })
}
 
// 推送退货单
export const ReturnOrderPush = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.ReturnOrderPush,
        method: 'post',
        data: data
    })
}
// 查询退货单对应进货单
export const getRestockOrder = (data: any): ConfigType<any> => {
    return request({
        url: `${DocumentsApi.getRestockOrder}?${qs.stringify(data)}`,
        method: 'get'
    })
}

// 推送退货单
export const ReturnOrderAdd = (data: any): ConfigType<any> => {
    return request({
        url: DocumentsApi.ReturnOrderAdd,
        method: 'post',
        data: data
    })
}
// 退货单打印
export const ReturnPrint = (data: any): ConfigType<any> => {
    return request({
        url: `${DocumentsApi.ReturnPrint}?${qs.stringify(data)}`,
        method: 'get'
    })
}

